// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  lotId: __t.u64().primaryKey().name("lot_id"),
  lotKey: __t.string().name("lot_key"),
  tier: __t.string(),
  renter: __t.identity(),
  storeName: __t.string().name("store_name"),
  rentedAt: __t.timestamp().name("rented_at"),
  expiresAt: __t.timestamp().name("expires_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
